//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';

export default {
    data: function data() {
        return {
            error: false,
            loading: false
        };
    },

    computed: {
        lang: function lang() {
            return this.$root._route.params.lang;
        },
        login_token: function login_token() {
            return this.$root._route.params.login_token;
        }
    },
    created: function created() {
        var _this = this;

        this.loading = true;
        var reqParams = this.$route.query;
        reqParams.registration_lang = this.lang;
        reqParams.login_token = this.login_token;
        axios.get(global.getEndPoint() + 'api/loginas', { /*headers: {'X-Cookie': this.getAllCookies()}, */params: reqParams }).then(function (res) {

            _this.loading = false;
            if (res.data.access_token) {
                _this.$auth.setToken(res.data.access_token, res.data.refresh_token, res.data.token_type, res.data.expires_in);
                _this.$parent.$emit('login-logout-event');

                customSessionStorage.removeItem('lastSearchText');
                customSessionStorage.removeItem('lastSearchType');

                _this.$router.push({ name: 'lang-successful-signup', params: { lang: _this.lang } });
            }
            if (res.data.success == 0) {
                _this.error = true;
            }
        }).catch(function (err) {
            _this.loading = false;
        });
    },

    methods: {
        getAllCookies: function getAllCookies() {
            if (process.client) {
                return document.cookie;
            }
            return '';
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/loginas/_login_token.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/loginas/_login_token.vue
// module chunks = 40